import type { RetirementStatusOption } from './RetirementStatusSelector.types'
import { RetirementStatus } from './RetirementStatusSelector.types'

export const retirementStatusOptionsMap: Record<RetirementStatus, RetirementStatusOption> = {
  [RetirementStatus.MoreThan5]: {
    label: '5+ years away',
    value: RetirementStatus.MoreThan5,
    links: [
      {
        text: 'Check how much you’ll need for retirement',
        href: 'https://www.which.co.uk/money/pensions-and-retirement/saving-for-retirement/how-much-will-you-need-to-retire-aNmlv7V7sVe9',
      },
      {
        text: 'Boost your pension',
        href: 'https://www.which.co.uk/money/pensions-and-retirement/saving-for-retirement/how-to-boost-your-pension-azMzj5E559rs',
      },
      {
        text: 'Track down and consolidate pension schemes',
        href: 'https://www.which.co.uk/money/pensions-and-retirement/saving-for-retirement/finding-lost-pensions-aK10i0v2EM8k',
      },
    ],
  },
  [RetirementStatus.LessThan5]: {
    label: 'Under 5 years',
    value: RetirementStatus.LessThan5,
    links: [
      {
        text: 'Use our calculator to forecast your pension pot',
        href: 'https://www.which.co.uk/money/pensions-and-retirement/accessing-your-pensions/your-options-for-cashing-in-your-pension/pension-calculator-how-much-money-youll-have-a9DH71u5ilAl',
      },
      {
        text: 'Consider how you’ll access your pension savings',
        href: 'https://www.which.co.uk/money/pensions-and-retirement/accessing-your-pensions/your-options-for-cashing-in-your-pension/options-for-cashing-in-your-pension-overview-aSwz74Y1XfCe',
      },
      {
        text: 'Check your state pension entitlement',
        href: 'https://www.which.co.uk/money/pensions-and-retirement/state-pension/how-much-state-pension-will-i-get-amwdv8F26J4T',
      },
    ],
    cta: {
      label: 'If you’re retiring soon, make a plan with Destination Retirement',
      disclaimer:
        'Which? earns commission to fund its not-for-profit mission if you buy a product via this service',
      button: {
        label: 'Book a call',
        href: 'https://business.hubfinancialsolutions.co.uk/which/destination-retirement?utm_source=Sidebar+tool1&utm_medium=sidebar+tool&utm_campaign=WhichDR',
      },
    },
  },
  [RetirementStatus.Retired]: {
    label: 'Already retired',
    value: RetirementStatus.Retired,
    links: [
      {
        text: 'Check you’re getting the benefits you’re entitled to',
        href: 'https://www.which.co.uk/money/pensions-and-retirement/accessing-your-pensions/perks-and-benefits-of-being-retired-aYK1U4o8AdIb',
      },
      {
        text: 'Read about the pros and cons of equity release',
        href: 'https://www.which.co.uk/money/pensions-and-retirement/equity-release/what-is-equity-release-aWHbh3k7xmWk',
      },
      {
        text: 'Find out what happens to your pension when you die',
        href: 'https://www.which.co.uk/money/pensions-and-retirement/accessing-your-pensions/what-happens-to-my-pension-when-i-die-ao5DX1S3uabQ',
      },
    ],
    cta: {
      label: 'Find out if equity release is right for you with Hub Financial Solutions',
      disclaimer:
        'Which? earns commission to fund its not-for-profit mission if you buy a product via this service',
      button: {
        label: 'Start now',
        href: 'https://business.hubfinancialsolutions.co.uk/which/equity-release?utm_source=which&utm_medium=advice&utm_campaign=sidebar',
      },
    },
  },
}

export const retirementStatusOptions: RetirementStatusOption[] = Object.values(
  retirementStatusOptionsMap
)
